// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"803":"6265dd81","7448":"86464dd4"}[chunkId] + ".chunk.css";
};